// src/RequireAuth.tsx
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from './app/hooks';
// adjust selector import to your slice:
import { selectLoginCredential } from './reducers/globalSlice';
import { logout } from './helpers/logout';

function isJwtExpired(jwt?: string) {
  if (!jwt) return true;
  try {
    const [, payloadB64] = jwt.split('.');
    const json = atob(payloadB64.replace(/-/g, '+').replace(/_/g, '/'));
    const { exp } = JSON.parse(json) as { exp?: number };
    if (!exp) return false; // if no exp, treat as not expired (backend will 401 if needed)
    return exp * 1000 < Date.now();
  } catch {
    return true;
  }
}

export default function RequireAuth({ children }: { children: JSX.Element }) {
  const cred = useAppSelector(selectLoginCredential);
  const location = useLocation();

  const token = cred?.credential;
  const notLoggedIn = !token || isJwtExpired(token);

  if (notLoggedIn) {
    logout();
    return <Navigate to="/" replace state={{ from: location }} />;
  }
  return children;
}
